<template>
    <div>
        <div class="searcher-container-negative mb-5 pb-2" style="width: auto;">
            <v-text-field v-model="search" label="Buscar nombre de plan empresarial"
                class="searcher form-control form-search" style="max-width: 330px;" single-line
                hide-details></v-text-field>
        </div>

        <v-data-table :headers="headersTabs" :items="desserts" item-key="name" :search="search"
            class="elevation-1 table align-middle table-licences text-center small" loading loading-text="Cargando..."
            mobile-breakpoint="0"
            :items-per-page="10" :footer-props="{
                prevIcon: 'fa-solid fa-chevron-left',
                nextIcon: 'fa-solid fa-chevron-right',
                'items-per-page-text': 'Mostrando: ',
                'items-per-page-options': [5, 10, 20, 30, 40, 50]
            }">
            <template v-slot:item="row">
                <tr>
                    <td>{{ row.item.id }}</td>
                    <td class="text-start">{{ row.item.name }}</td>
                    <td><a :href="redirect+'?lic='+row.item.uuid">{{ row.item.clientes_activos }}</a></td>
                    <td>{{ row.item.accepted_users }}</td>
                    <td>{{ row.item.accepted_routes }}</td>
                    <td>{{ row.item.accepted_courses }}</td>
                    <td>{{ row.item.expiration_date }}</td>
                    <td>
                        <div class="d-flex gap-3">
                            <button type="button" class="text-primary" data-bs-toggle="modal"
                                :id="'updateModel-' + row.item.id" data-bs-target="#updateModal"
                                alt="Editar esta licencia" title="Editar esta licencia"
                                @click="abrirModalActualizar(row.item)">
                                <i class="fa-solid fa-pen-to-square"></i>
                            </button>
                            <button alt="Eliminar esta licencia" title="Eliminar esta licencia" type="button"
                                class="text-primary" data-bs-toggle="modal" data-bs-target="#deleteModal"
                                @click="destroy = row.item">
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <!-- edit -->
        <div class="modal fade" id="updateModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="updateModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-utel text-light">
                        <h5 class="modal-title">Editar licencia</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col">
                                <label class="x-small-mb">Nombre de la licencia</label>
                                <input type="text" v-model="edit.name" class="form-control"
                                    placeholder="Nombre de la licencia" aria-label="Nombre de la licencia" />
                            </div>
                            <span class="text-danger" v-if="error.name">El nombre de la licencia es un campo
                                obligatorio</span>
                        </div>
                        <div class="row g-3">
                            <div class="col m-0">
                                <label class="x-small-mb">Número de usuarios disponibles</label>
                                <input type="number" @change="validarCuposDisponibles($event, 'usuarios')"
                                    :min="edit.accepted_users" v-model="edit.accepted_users" class="form-control"
                                    placeholder="Apellido del usuario" aria-label="Apellido del usuario" />

                                <span class="text-danger" v-if="error.accepted_users">El apellido del usuario es un
                                    campo
                                    obligatorio</span>
                            </div>
                            <div class="col m-0">
                                <label class="x-small-mb">Número de rutas disponibles</label>
                                <input type="number" @change="validarCuposDisponibles($event, 'rutas')"
                                    :min="edit.accepted_routes" v-model="edit.accepted_routes" class="form-control"
                                    placeholder="Rutas disponibles" aria-label="Rutas disponibles" />

                                <span class="text-danger" v-if="error.accepted_users">{{ error }} <br /></span>
                            </div>
                            <div class="col m-0">
                                <label class="x-small-mb">Número total de cursos</label>
                                <input type="email" @change="validarCuposDisponibles($event, 'cursos')"
                                    :min="edit.accepted_courses" v-model="edit.accepted_courses" class="form-control"
                                    placeholder="Total de cursos" aria-label="Total de cursos" />

                                <span class="text-danger" v-if="error.accepted_courses">{{ error }} <br /></span>
                            </div>
                        </div>
                        <div class="row g-3">
                            <label class="x-small-mb">Tiempo de Licencia</label>
                            <div class="col m-0">
                                <input type="number" v-model="edit.expiration_day" class="form-control"
                                    placeholder="Tiempo de la Licencia" aria-label="Tiempo de la Licencia" />
                                <span class="text-danger" v-if="error.digits">Por favor ingrese el tiempo de
                                    licencia.</span>
                            </div>
                            <div class="col m-0">
                                <select v-model="edit.expiration_type" class="form-control p-2">
                                    <option value="" selected="selected" disabled>Seleccione el tipo de tiempo</option>
                                    <option value="hours">Horas</option>
                                    <option value="days">Días</option>
                                    <option value="month">Meses</option>
                                    <option value="years">Años</option>
                                </select>
                                <span class="text-danger" v-if="error.expiration_date">Por favor seleccione el tipo de
                                    tiempo de la licencia.</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="cancel" type="button" class="btn btn-utel btn-inverted d-none d-lg-block" data-bs-dismiss="modal"
                            @click="edit = []">
                            Cerrar
                        </button>
                        <button id="update" type="button" @click="editarCliente" class="btn btn-utel text-light">
                            Guardar cambios
                        </button>
                        <button id="cancel" type="button" class="btn btn-utel btn-inverted d-lg-none" data-bs-dismiss="modal"
                            @click="edit = []">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- fin edit -->
        <!-- delete -->
        <div class="modal fade" id="deleteModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="deleteModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Eliminar licencia
                        </h5>
                    </div>
                    <div class="modal-body text-center">
                        <span id="response">¿Esta seguro de eliminiar la licencia
                            <b>{{ destroy.name }}</b>?</span>
                    </div>
                    <div class="modal-footer">
                        <button id="close" type="button" class="btn btn-utel btn-inverted" data-bs-dismiss="modal"
                            @click="destroy = []">
                            Cerrar
                        </button>
                        <button id="delete" type="button" @click="eliminarCliente" class="btn-utel text-light">
                            Eliminar licencia
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- fin delete -->

        <!-- confirmación eliminar -->
        <button id="succesDeleteBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal"
            data-bs-target="#succesDelete">
        </button>
        <div class="modal fade" id="succesDelete" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="succesDeleteLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesDeleteLabel">Eliminado</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha eliminado <br> correctamente el plan.
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light"
                            data-bs-dismiss="modal">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- create -->
        <div class="modal fade" id="addModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="addModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">Agregar nueva licencia</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col">
                                <label class="x-small-mb">Nombre de la licencia</label>
                                <input type="text" v-model="newUser.name" class="form-control"
                                    placeholder="Nombre de la licencia" aria-label="Nombre de la licencia" />
                            </div>
                            <span class="text-danger" v-if="error.name">El nombre de la licencia es un campo
                                obligatorio</span>
                        </div>

                        <div class="row g-3">
                            <div class="col m-0">
                                <label class="x-small-mb">Número de usuarios disponibles</label>
                                <input type="number" min="0" v-model="newUser.accepted_users" class="form-control"
                                    placeholder="Apellido del usuario" aria-label="Apellido del usuario" />

                                <span class="text-danger" v-if="error.accepted_users">El apellido del usuario es un
                                    campo
                                    obligatorio</span>
                            </div>
                            <div class="col m-0">
                                <label class="x-small-mb">Número de rutas disponibles</label>
                                <input type="number" min="0" v-model="newUser.accepted_routes" class="form-control"
                                    placeholder="Rutas disponibles" aria-label="Rutas disponibles" />

                                <span class="text-danger" v-if="error.accepted_users">{{ error }} <br /></span>
                            </div>
                            <div class="col m-0">
                                <label class="x-small-mb">Número total de cursos</label>
                                <input type="email" min="0" v-model="newUser.accepted_courses" class="form-control"
                                    placeholder="Total de cursos" aria-label="Total de cursos" />

                                <span class="text-danger" v-if="error.accepted_courses">{{ error }} <br /></span>
                            </div>
                        </div>
                        <div class="row g-3">
                            <label class="x-small-mb mt-0 mb-1">Tiempo de Licencia</label>
                            <div class="col m-0 pt-0">
                                <input type="number" v-model="newUser.digits" class="form-control"
                                    placeholder="Tiempo de la Licencia" aria-label="Tiempo de la Licencia" />
                                <span class="text-danger" v-if="error.digits">Por favor ingrese el tiempo de
                                    licencia.</span>
                            </div>
                            <div class="col m-0 pt-0">
                                <select v-model="newUser.typeTime" class="form-control p-2">
                                    <option value="" selected="selected" disabled>Seleccione el tipo de tiempo</option>
                                    <option value="hours">Horas</option>
                                    <option value="days">Días</option>
                                    <option value="month">Meses</option>
                                    <option value="years">Años</option>
                                </select>
                                <span class="text-danger" v-if="error.expiration_date">Por favor seleccione el tipo de
                                    tiempo de la licencia.</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="closeAdd" type="button" class="btn-inverted btn-utel btn d-none d-lg-block" data-bs-dismiss="modal"
                            @click="
                                newUser = {
                                    name: '',
                                    accepted_users: 0,
                                    accepted_routes: 0,
                                    accepted_courses: 0,
                                    digits: 0,
                                    typeTime: '',
                                }
                            ">
                            Cerrar
                        </button>
                        <button id="agregar" type="button" @click="agregarCliente" class="btn-utel text-light">
                            Crear licencia
                        </button>
                        <button id="closeAdd" type="button" class="btn-inverted btn-utel btn d-lg-none" data-bs-dismiss="modal"
                            @click="
                                newUser = {
                                    name: '',
                                    accepted_users: 0,
                                    accepted_routes: 0,
                                    accepted_courses: 0,
                                    digits: 0,
                                    typeTime: '',
                                }
                            ">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirmación crea -->
        <button id="succesCreateBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal"
            data-bs-target="#succesCreate">
        </button>
        <div class="modal fade" id="succesCreate" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="succesCreateLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesCreateLabel">Creación</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha creado<br>la licencia correctamente.
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light"
                            data-bs-dismiss="modal">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["get", "headertab", "idlicencia", 'redirect'],
    data() {
        return {
            search: '',
            headersTabs: this.headertab,
            url: this.get,
            desserts: [],
            edit: [],
            acceptedUserOriginal: 0,
            acceptedCourseOriginal: 0,
            acceptedRouteOriginal: 0,
            destroy: [],
            newUser: {
                name: "",
                accepted_users: 0,
                accepted_routes: 0,
                accepted_courses: 0,
                digits: null,
                typeTime: '',
            },
            error: [],
        };
    },
    mounted() {
        this.getData();
        this.editModal();
    },
    methods: {
        getData() {
            axios.get(this.url).then((res) => {
                this.desserts = res.data;
            });
        },
        editarCliente() {
            let btn = document.getElementById("update");
            let cancel = document.getElementById("cancel");
            let modal = document.getElementById("updateModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .put(this.url + "/" + this.edit.id, this.edit)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        btn.textContent = "Actualizar Usuario";
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => {
                    if (!err.response) return
                    this.$swal(err.response.data.message);

                    btn.textContent = "Actualizar Usuario";
                    cancel.removeAttribute("disabled");
                    btn.removeAttribute("disabled");
                });
        },
        eliminarCliente() {
            const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            let succesDeleteBtn = document.getElementById("succesDeleteBtn");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.id)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Eliminar";
                        succesDeleteBtn.click();
                    }, 500);
                })
                .catch((err) => {
                    console.log(err.error);
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });
        },
        agregarCliente() {
            let btn = document.getElementById("agregar");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            let succesCreateBtn = document.getElementById("succesCreateBtn");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .post(this.url, this.newUser)
                .then((res) => {
                    this.newUser = {
                        name: "",
                        accepted_users: 0,
                        accepted_routes: 0,
                        accepted_courses: 0,
                        expiration_date: "",
                    };
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        btn.textContent = "Guardar usuario";
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        succesCreateBtn.click();
                    }, 500);
                })
                .catch((err) => {
                    cancel.removeAttribute("disabled");
                    btn.removeAttribute("disabled");
                    btn.textContent = "Guardar proceso";
                    this.error = err.response.data.errors;
                });
        },
        editModal() {
            setTimeout(() => {
                console.log("updateModel-" + this.idlicencia);
                document.getElementById("updateModel-" + this.idlicencia).click();
            }, 1500);
        },
        abrirModalActualizar(item) {
            this.edit = item;
            this.acceptedUserOriginal = item.accepted_users;
            this.acceptedCourseOriginal = item.accepted_courses;
            this.acceptedRouteOriginal = item.accepted_routes;
        },
        validarCuposDisponibles(val, tipo) {
            const value = parseInt(val.target.value);

            switch (tipo) {
                case "usuarios":
                    if (value < this.acceptedUserOriginal) {
                        this.$swal(`El número de usuarios disponibles de esta licencia no debe ser menor a ${this.acceptedUserOriginal}`);
                        this.edit.accepted_users = this.acceptedUserOriginal;
                    }
                    break;

                case "rutas":
                    if (value < this.acceptedRouteOriginal) {
                        this.$swal(`El número de rutas disponibles de esta licencia no debe ser menor a ${this.acceptedRouteOriginal}`);
                        this.edit.accepted_routes = this.acceptedRouteOriginal;
                    }
                    break;
                case "cursos":
                    if (value < this.acceptedCourseOriginal) {
                        this.$swal(`El número de cursos disponibles de esta licencia no debe ser menor a ${this.acceptedCourseOriginal}`);
                        this.edit.accepted_courses = this.acceptedCourseOriginal;
                    }
                    break;
            }
        }
    },
};
</script>
